
export default function($t) {
  return [
      {
      name: 'columnName',
      is_visible: true,
      get short_title() {
          return $t('OptionalFields.field_name')
      },
      get title() {
          return $t('OptionalFields.field_name')
      }
      },

      {
      name: 'columnType',
      type: 'portal',
      is_visible: true,
      headerTitle: true,
      get short_title() {
          return $t('OptionalFields.filed_type_short')
      },
      get title() {
          return $t('OptionalFields.filed_type_short')
      }
      },

      {
      name: 'tableType',
      type: 'portal',
      is_visible: true,
      get short_title() {
          return $t('OptionalFields.field_module_name')
      },
      get title() {
          return $t('OptionalFields.field_module_name')
      }
      },

      {
      name: 'isRequired',
      is_visible: true,
      type: 'portal',
      get short_title() {
          return $t('OptionalFields.field_validate_required') 
      },
      get title() {
          return $t('OptionalFields.field_validate_required') 
      }
      },

      {
      name: 'isUnique',
      is_visible: true,
      type: 'portal',
      get short_title() {
          return $t('OptionalFields.field_validate_unique')
      },
      get title() {
          return $t('OptionalFields.field_validate_unique')
      }
    }
  ]
}
